"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FullScreenLoader = _interopRequireDefault(require("../../../IconicDisplayElements/FullScreenLoader"));

var _propTypes2 = _interopRequireDefault(require("../../../../constants/propTypes"));

var _getComponent = _interopRequireDefault(require("../../../../utils/getComponent"));

var _LayoutFullPage = require("./LayoutFullPage.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// external
// ours
// resources

/**
 * LayoutFullPage - Full page layout wrapper component
 * including header, mobile-nav, side-nav and content
 */
var LayoutFullPage = function LayoutFullPage(_ref) {
  var className = _ref.className,
      children = _ref.children,
      doneLoading = _ref.doneLoading,
      doneLoadingMessage = _ref.doneLoadingMessage,
      isLoading = _ref.isLoading,
      loaderMessage = _ref.loaderMessage,
      _inStyleGuide = _ref._inStyleGuide;
  return (
    /*#__PURE__*/
    // header is placed above teh progress par via styles but since they are placed via 'fixed' on mobile,
    // header must come after progress bar for correct layering.
    _react.default.createElement(_LayoutFullPage.StyledLayoutFullPage, {
      className: className
    }, /*#__PURE__*/_react.default.createElement(_FullScreenLoader.default, {
      dataTestId: "layout-full-page-loader",
      doneLoading: doneLoading,
      doneLoadingMessage: doneLoadingMessage,
      loading: isLoading,
      message: loaderMessage,
      _inStyleGuide: true
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: ['c-layout-full-page-header', _inStyleGuide ? 'c-layout-full-page-remove-fixed' : null].join(' ')
    }, (0, _getComponent.default)('header', children)), /*#__PURE__*/_react.default.createElement("div", {
      className: ['c-layout-full-page-side-nav', _inStyleGuide ? 'c-layout-full-page-remove-fixed' : null].join(' ')
    }, (0, _getComponent.default)('side-nav', children)), /*#__PURE__*/_react.default.createElement("div", {
      className: ['c-layout-full-page-content', _inStyleGuide ? 'c-layout-full-page-remove-fixed' : null, isLoading || doneLoading ? 'c-layout-full-page-blur' : undefined].join(' ')
    }, (0, _getComponent.default)('content', children)))
  );
};

LayoutFullPage.propTypes = {
  /** Collection of items to be slotted into the content containers.
   * <br />Valid child keys are are: header, sideNav, mobileNav, content.
   * <br/>Children can be any valid node or array of valid nodes.
   */
  children: _propTypes2.default.children,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,
  // dataTestId is intentionally omitted from this class as it is just a wrapper

  /** (optional) Indicates if loading has finished as a precursor to showing doneLoadingMessage */
  doneLoading: _propTypes.default.bool,

  /** (optional) Message to show for loading completion screen */
  doneLoadingMessage: _propTypes.default.string,

  /** flag to indicate loading state */
  isLoading: _propTypes.default.bool,

  /** message to display in the loader when visible */
  loaderMessage: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]),

  /** a flag specifically for the styleguide - used to turn off fixed positioning */
  _inStyleGuide: _propTypes.default.bool
};
LayoutFullPage.defaultProps = {
  children: undefined,
  className: '',
  doneLoading: false,
  doneLoadingMessage: undefined,
  isLoading: false,
  loaderMessage: undefined,
  _inStyleGuide: false
};
var _default = LayoutFullPage;
exports.default = _default;